import { Typography } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { useDateFormatter } from '@/hooks';

interface CallInsightsHeaderProps {
    createdAt: Date | null;
    updatedAt: Date | null;
}

const CallInsightsHeader: React.FC<CallInsightsHeaderProps> = ({ createdAt, updatedAt }) => {
    const hasInsights = createdAt || updatedAt;
    const formatDate = useDateFormatter();

    return (
        <Typography sx={{ fontSize: 12, color: 'gray.60', display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <AutoAwesome sx={{ fontSize: 12, color: 'gray.60' }} />
            {hasInsights
                ? `Insights generated ${formatDate(updatedAt || createdAt)}.`
                : 'Insights have not been generated yet for this call.'}
        </Typography>
    );
};

export default CallInsightsHeader;
